import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../Icon';
import styles from './TestimonialCard.css';

const STARS_COUNT = 5;

function TestimonialCard({ quote, author }) {
    return (
        <li className={styles.root}>
            <span className={styles.stars} role='img' aria-label={`Rated ${STARS_COUNT} out of ${STARS_COUNT}`}>
                {Array.from({ length: STARS_COUNT }, (_, index) => (
                    <Icon key={index} name='starFilled' className={styles.star} />
                ))}
            </span>
            <p className={styles.quote}>{quote}</p>
            <footer className={styles.author}>
                <span className={styles.avatar} aria-hidden='true'>{author[0]}</span>
                <p className={styles.name}>{author}</p>
            </footer>
        </li>
    );
}

TestimonialCard.propTypes = {
    quote: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired
};

export {
    TestimonialCard
};
